<script>
import { throttle } from "../assets/js/utils"

export default {
  name: "dgDrag",
  props: {

    index: Number,
    xy: Array
  },
  data() {
    return {
      z: 1,
      editing: false,
      moving: false,
      editedText: null,
      tgt: null,
      clickTimer: null,

    }
  },
  watch: {
    xy: {
      handler(val) {

        if (val) {

          this.$nextTick(() => {
            if (val[0] && val[1]) {
              this.setPos(val[0], val[1])
              // this.posinfo.value = {
              //   x: parseInt(val[0]),
              //   y: parseInt(val[1])
              // }

              this.$emit('setPosinfo', {
                x: parseInt(val[0]),
                y: parseInt(val[1]),
                index: this.index
              })

            }
          })
        }
      },
      immediate: true
    },
  },
  methods: {
    editText(evt) {
      this.editedText = evt.target;
      this.editing = true;
      this.editedText.focus();
    },
    handleTouch(evt) {
      evt.preventDefault();
      this.drag(evt);
      if (this.clickTimer == null) {
        this.clickTimer = setTimeout(function () {
          this.clickTimer = null;
        }, 500);
      } else {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
        this.editText(evt);
      }
    },


    end() {
      this.moving = false;
    },

    setPos(x, y) {
      let element = this.$refs.dg__drag

      let xy = "left:" + x + "px; top:" + y + "px;";
      element.setAttribute("style", xy);
      this.emitFn({ y: element.offsetTop, x: element.offsetLeft });
    },
    emitFn() { }
  },
  mounted() {
    let mov = false;
    let _this = this;
    function drag(element, elWrap) {
      var position = {
        offsetX: 0, //点击处偏移元素的X
        offsetY: 0, //偏移Y值
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      };
      element.addEventListener("mousedown", function (ev) {
        startmove(ev)
        ev.preventDefault();
      }, false);
      element.addEventListener("touchstart", function (ev) {
        startmove(ev)
        ev.preventDefault();
      }, false);
      element.addEventListener("touchmove", function (ev) {
        // 核心代码
        let event = getEvent(ev);
        if (mov) {
          _this.$emit('move', {})
          main(event)
        }
        ev.preventDefault();
      }, false);
      element.addEventListener("mousemove", function (ev) {
        // 核心代码
        let event = getEvent(ev);
        if (mov) {
          _this.$emit('move', {})
          main(event)
        }
        ev.preventDefault();
      }, false);


      element.addEventListener(
        "mouseup",
        function (ev) {
          mov = false;
          _this.$emit('mouseup', {})
          // elWrap.setAttribute("style", "overflow-y: auto")
          ev.preventDefault();
        },
        false
      );
      element.addEventListener(
        "touchend",
        function (ev) {
          mov = false;
          ev.preventDefault();
          _this.$emit('mouseup', {})
          //  elWrap.setAttribute("style", "overflow-y: auto");
        },
        false
      );

      function startmove(ev) {
        mov = true;
        let event = getEvent(ev);
        position.w = element.offsetWidth;
        position.h = element.offsetHeight;
        position.x = element.offsetLeft;
        position.y = element.offsetTop;
        position.offsetX = event.pageX || event.changedTouches[0].pageX; // 鼠标的距离
        position.offsetY = event.pageY || event.changedTouches[0].pageY; // 鼠标的距离
        //  elWrap.setAttribute("style", "overflow-y: hidden");
      }

      function main(event) {
        let pageX = event.changedTouches[0].pageX; //移动时 鼠标的位置
        let pageY = event.changedTouches[0].pageY; //移动时 鼠标的位置
        let dx = pageX - position.offsetX + position.x;
        let dy = pageY - position.offsetY + position.y;
        if (dx < 0) {
          dx = 0;
        }
        if (dx + position.w > elWrap.offsetWidth) {
          dx = elWrap.offsetWidth - position.w;
        }
        if (dx < 0) {
          dx = 0;
        }
        if (dx + position.w > elWrap.offsetWidth) {
          dx = elWrap.offsetWidth - position.w;
        }
        if (dy < 0) {
          dy = 0;
        }
        if (dy + position.h > elWrap.offsetHeight) {
          dy = elWrap.offsetHeight - position.h;
        }
        let xy = "left:" + dx + "px; top:" + dy + "px; z-index:10;";
        element.setAttribute("style", xy);
        _this.emitFn({ y: element.offsetTop, x: element.offsetLeft });
      }


    }

    this.emitFn = throttle((v) => {
      // this.posinfo.value = v
      this.$emit('setPosinfo', {
        ...v, index: this.index
      })

    }, 100)

    drag(this.$refs.dg__drag, document.getElementById('pdf-box'));
    // drag(this.$refs.dg__drag, this.$parent.$el);
    function getEvent(event) {
      return event || window.event;
    }
  },
  render(h) {
    return h('div', {
      class: ['dg__drag'],
      ref: "dg__drag",
    }, this.$slots.default);
  }
}
</script>
<style scoped></style>